import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("embed", {
  class: "m-auto",
  src: "/assets/pdf/supairvision-vision-cgu.pdf",
  width: "1200",
  height: "800",
  type: "application/pdf"
}, null, -1)

import {
  NkContainer,
  NkStack,
  NkHeading,
  NkBox,
  NkGroup,
  NkCol, NkGrid, NkIcon, NkText, NkButton,
} from '@/core/components';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkRessource',
  setup(__props) {

const view = ref(1);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NkContainer), { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_unref(NkStack), { spacing: 8 }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkBox), null, {
            default: _withCtx(() => [
              _createVNode(_unref(NkGroup), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NkHeading), { type: "underlined" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('resource.title')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(NkGrid), { justify: "between" }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkCol), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NkStack), { spacing: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NkGroup), { spacing: 4 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NkButton), {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (view.value = 1)),
                            type: view.value === 1 ? 'white' : 'primary'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('resource.cgu.title')), 1)
                            ]),
                            _: 1
                          }, 8, ["type"])
                        ]),
                        _: 1
                      }),
                      (view.value === 1)
                        ? (_openBlock(), _createBlock(_unref(NkGroup), { key: 0 }, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})